// @flow
import React, {PureComponent} from 'react'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import ReactTable from 'react-table'
import styles from './AdminCompanyList.module.scss'
import 'react-table/react-table.css'
import {adminURL} from 'modules/Common/constants'
import {formatTimestampToDate} from 'modules/Common/utils'

import AddCompanyModal from './AddCompanyModal'
import PenIcon from '../svgIcons/pen.svg'

import type {
  StateProps,
  DispatchProps,
  OwnProps
} from '../../containers/AdminCompanyListContainer'

export type Props = DispatchProps & StateProps & OwnProps;

export type State = {
  isShowAddModal: boolean
};

const I18nLocal = I18n.admin

export class AdminCompanyList extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isShowAddModal: false
    }
  }

  handleOpenAddModal = () => {
    this.setState({
      isShowAddModal: true
    })
  }
  handleCloseAddModal = () => {
    this.setState({
      isShowAddModal: false
    })
  }
  fetchData = (state: any, instance: any) => {
    this.props.getCompanies(state.page + 1)
  }
  calculateData = () => {
    return this.props.companies.ids.map(key => {
      const item = this.props.companies.records[key] || {}
      return {
        id: item.id,
        company: item.fullName,
        location: item.location,
        accountManagers: item.amCount,
        dateRegistered: formatTimestampToDate(
          item.creationTimestamp,
          'HH:mm DD/MM/YYYY'
        )
      }
    })
  }

  render() {
    const data = this.calculateData()

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <span>{I18nLocal.companies}</span>
          <div onClick={this.handleOpenAddModal} className={styles.button}>
            {I18nLocal.addCompany}
          </div>
        </div>
        <div className={styles.table}>
          <ReactTable
            showPageSizeOptions={false}
            sortable={false}
            data={data}
            columns={[
              {
                id: 'index',
                Header: '#',
                Cell: props => {
                  return props.index + 1
                }
              },
              {
                id: 'company',
                Header: I18nLocal.companyName,
                Cell: props => {
                  return (
                    <Link
                      className={styles['link']}
                      to={adminURL.companies.detail.replace(
                        ':id',
                        props.original.id
                      )}
                    >
                      {props.original.company}
                    </Link>
                  )
                }
              },
              {
                Header: I18nLocal.location,
                accessor: 'location'
              },
              {
                Header: I18nLocal.accountManagers,
                accessor: 'accountManagers'
              },
              {
                Header: I18nLocal.dateRegistered,
                accessor: 'dateRegistered'
              },
              {
                Header: '',
                Cell: props => {
                  return (
                    <Link
                      className={styles['edit-button']}
                      to={adminURL.companies.edit.replace(
                        ':id',
                        props.original.id
                      )}
                    >
                      <PenIcon width={15} height={15} />
                    </Link>
                  )
                }
              }
            ]}
            manual
            pages={this.props.companies.numberOfPages}
            loading={this.props.isLoadingCompanies}
            onFetchData={this.fetchData}
          />
        </div>
        <AddCompanyModal
          handleClickButton={this.props.addOrUpdateCompany}
          handleClose={this.handleCloseAddModal}
          isShow={this.state.isShowAddModal}
          error={this.props.error}
        />
      </div>
    )
  }
}

export default AdminCompanyList
